import api from '@/services/api'

export default class EvaluationQuestionAPI {
  static EVALUATION_QUESTION_ENDPOINT = 'evaluation-questions'
  /**
   * Initialize a `EvaluationQuestionAPI` instance.
   *
   * @param {class} cls  The class to use to create evaluationResponse objects.
   **/
  constructor(cls) {
    this.cls = cls
  }

  /**
   * Factory method to create a new instance of `EvaluationQuestionAPI`.
   *
   * @param {class} cls      The class to use to create evaluationResponse objects.
   **/
  static create(cls) {
    return new EvaluationQuestionAPI(cls)
  }

  /**
   * Get the API Client.
   */
  get client() {
    return api.getApiClient()
  }

  /**
   * Retrieve one evaluationResponse from the API.
   *
   * @param {String} evaluationQuestionId  Unique ID of the evaluation to retrieve.
   */
  get(evaluationQuestionId) {
    const url = `${EvaluationQuestionAPI.EVALUATION_QUESTION_ENDPOINT}/${evaluationQuestionId}/`
    return this.client.get(url).then(response => this.cls.fromAPI(response.data))
  }

  /**
   * Get all evaluationResponse through the API.
   *
   *
   */
  // eslint-disable-next-line no-unused-vars
  list({ filters = {} } = {}) {
    const url = `${EvaluationQuestionAPI.EVALUATION_QUESTION_ENDPOINT}/`
    const options = {
      params: {},
    }

    return this.client
      .get(url, options)
      .then(response => response.data)
      .then(data => {
        // To Do, add data.results instead of data when you add pagination
        data.results = data.results.map(this.cls.fromAPI)
        return data
      })
  }

  /**
   * Update a evaluationResponse through the API.
   *
   * @param {evaluationQuestion} evaluationQuestion data to send to the API.
   */
  update(evaluationQuestion, fields = [], excludeFields = []) {
    const url = `${EvaluationQuestionAPI.EVALUATION_QUESTION_ENDPOINT}/${evaluationQuestion.id}/`
    const data = this.cls.toAPI(evaluationQuestion, fields, excludeFields)
    return this.client.patch(url, data).then(response => this.cls.fromAPI(response.data))
  }
}
